
export const environment = {
    production: true,
    baseUrl: "https://supersonic.agilitygis.com/api",
    integrationUrl: 'https://supersonic-integration.agilitygis.com/api',
    strapiUrl: 'https://supersonic.sudosky.com/api',
    strapiJWTToken: 'Bearer 6ebb671412e42506d0b09bfd5881d9bb9891ba902c549d2cb31b3b86881a49ce28aeb3b16eb1a79e9e9e155b34651c93f0a8dff47de565863442c605a7b982d84fdc9a22fa0ec00944cb99ee8a88399546a79c5b30928182ec36bd4882a943f317314b1fdf608a08b7a22d42c590f34874529b464204ff9f72db245fac078433',
    recaptchaSiteKeyTest: '6Ld2I9QpAAAAADAclUIc6bCMfXPxb4vki2fP9It-',
    googleAnalyticsCode: 'GTM-MBHQ44Z3',
    organisationId: '5122336'

    // production: false,

    // baseUrl: "https://supersonic-customer-staging.agilitygis.com/api",
    // integrationUrl: 'https://integration-staging.agilitygis.com/api',
    // strapiUrl: 'https://supersonic-uat-strapi.sudosky.com/api',
    // strapiJWTToken: 'Bearer 6ebb671412e42506d0b09bfd5881d9bb9891ba902c549d2cb31b3b86881a49ce28aeb3b16eb1a79e9e9e155b34651c93f0a8dff47de565863442c605a7b982d84fdc9a22fa0ec00944cb99ee8a88399546a79c5b30928182ec36bd4882a943f317314b1fdf608a08b7a22d42c590f34874529b464204ff9f72db245fac078433',
    // recaptchaSiteKeyTest: '6Ld2I9QpAAAAADAclUIc6bCMfXPxb4vki2fP9It-',
    // googleAnalyticsCode: 'GTM-MBHQ44Z3',
    
};


